import { useEffect, useState } from 'react';

function createNoiseTexture() {
  const size = 150;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return '';
  }
  const imageData = ctx.createImageData(size, size);
  for (let i = 0; i < imageData.data.length; i += 4) {
    const v = Math.random() * 255;
    imageData.data[i] = v;
    imageData.data[i + 1] = v;
    imageData.data[i + 2] = v;
    imageData.data[i + 3] = 255;
  }
  ctx.putImageData(imageData, 0, 0);
  return canvas.toDataURL();
}

export function useNoiseEasterEgg() {
  const [noise, setNoise] = useState({ active: false, url: '' });

  useEffect(() => {
    let count = 0;
    let timer: ReturnType<typeof setTimeout>;

    function onKeyDown(e: KeyboardEvent) {
      if (e.key !== 'Escape') {
        return;
      }
      count++;
      clearTimeout(timer);
      if (count >= 3) {
        setNoise((prev) => ({ active: !prev.active, url: prev.url || createNoiseTexture() }));
        count = 0;
      }
      timer = setTimeout(() => {
        count = 0;
      }, 1000);
    }

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      clearTimeout(timer);
    };
  }, []);

  return noise;
}
